import QuestionBody from "./QuestionBody";

export default QuestionBody;
